import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-export-questions-dropdown";

const keys = addTranslations(RESOURCE_NAME, {
    trigger_button: {
        en: "Export",
        fr: "Exporter",
    },
    export_answers_in_locale: {
        en: "Export answers in {{locale}}",
        fr: "Exporter les réponses en {{locale}}",
    },
    export_files: {
        en: "Export proof documents",
        fr: "Exporter les documents",
    },
});

export function useExportQuestionsDropdownTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
